import { apiRoutes } from "@/services/api/routes";
import formDataClient from "@/services/axios/formData-client";
const formDataConfig = {
  headers: {
    "Content-Type": "multipart/form-data",
  },
};

export const addBusinessDetails = async (formValue: FormData) => {
  try {
    return await formDataClient.post(
      apiRoutes().buyer.business.addUpdate,
      formValue,
      formDataConfig
    );
  } catch (exception) {
    throw exception;
  }
};